var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "light": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "grey darken-2"
    }
  }, [_vm._v("arrow_back")])], 1), _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.back')))])], 1), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + " ")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": "",
      "color": "blue"
    },
    on: {
      "click": function click($event) {
        return _vm.openNewMessageDialog();
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "text-xs-center": ""
    }
  }, [_vm.messagesLoading ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "grey lighten-2",
      "size": 100,
      "width": 10
    }
  }) : _c('v-card', [_vm.messages.length > 0 ? _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_vm._l(_vm.messages, function (item, index) {
    return [_c('v-list-tile', {
      key: index,
      class: {
        unread: !item.isRead
      },
      attrs: {
        "avatar": "",
        "to": {
          name: 'webmailshow',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('v-list-tile-avatar', {
      attrs: {
        "color": "indigo"
      }
    }, [_c('span', {
      staticClass: "white--text title"
    }, [_vm._v(_vm._s(item.from ? item.from.emailAddress.name.split(' ').map(function (i) {
      return i.charAt(0);
    }).join('') : 'NA'))])]), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.from ? item.from.emailAddress.name : '')
      }
    }), _c('v-list-tile-sub-title', {
      staticClass: "content body-1",
      domProps: {
        "innerHTML": _vm._s(item.subject)
      }
    }), _c('v-list-tile-sub-title', {
      staticClass: "content caption",
      domProps: {
        "innerHTML": _vm._s(item.bodyPreview)
      }
    })], 1), _c('v-list-tile-action', {
      staticClass: "action"
    }, [_c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formatDate(item.receivedDateTime)))]), item.hasAttachments ? _c('v-icon', {
      attrs: {
        "color": "grey lighten-1",
        "small": ""
      }
    }, [_vm._v("\n                    attach_file\n                  ")]) : _vm._e()], 1)], 1)];
  })], 2) : _c('v-alert', {
    attrs: {
      "value": true,
      "color": "info",
      "icon": "info",
      "outline": ""
    }
  }, [_vm._v("\n            Your mailbox is empty\n          ")])], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "white",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.closeNewMessageDialog();
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _c('v-toolbar-title', [_vm._v("New Message")]), _c('v-spacer'), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.sendMessage();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("\n              send\n            ")])], 1)], 1)], 1), _c('v-divider'), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.contacts,
      "loading": _vm.isLoading,
      "search-input": _vm.search,
      "item-text": "scoredEmailAddresses[0].address",
      "item-value": "scoredEmailAddresses[0].address",
      "color": "white",
      "label": "To",
      "return-object": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "deletable-chips": "",
      "small-chips": ""
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.search = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.search = $event;
      }
    },
    model: {
      value: _vm.to,
      callback: function callback($$v) {
        _vm.to = $$v;
      },
      expression: "to"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.contacts,
      "loading": _vm.isLoading,
      "search-input": _vm.search,
      "item-text": "scoredEmailAddresses[0].address",
      "item-value": "scoredEmailAddresses[0].address",
      "color": "white",
      "label": "CC",
      "return-object": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "deletable-chips": "",
      "small-chips": ""
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.search = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.search = $event;
      }
    },
    model: {
      value: _vm.cc,
      callback: function callback($$v) {
        _vm.cc = $$v;
      },
      expression: "cc"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "no-border pa-1",
    attrs: {
      "prefix": "Subject:"
    },
    model: {
      value: _vm.subject,
      callback: function callback($$v) {
        _vm.subject = $$v;
      },
      expression: "subject"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "name": "message",
      "label": "Message",
      "auto-grow": ""
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  })], 1), _c('attachments')], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }